const Module = {
  module: 'Module',
  addModule: 'Add Module',
  editModule: 'Edit Module',
};
export default Module;
